var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("totals")))]),
              _c(
                "w-sortable",
                {
                  attrs: {
                    items: _vm.view.Totals,
                    "disable-x": "",
                    "keep-in-y": "",
                    tag: "w-list",
                    "target-class": "handle",
                  },
                },
                _vm._l(_vm.view.Totals, function (total, i) {
                  return _c(
                    "w-list-item",
                    { key: i, attrs: { "show-handle": "" } },
                    [
                      _c("w-list-item-text", [
                        _vm._v(
                          _vm._s(total.Label.getTranslation(_vm.$i18n.locale))
                        ),
                      ]),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("edit-total"),
                                  expression: "$ct('edit-total')",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.editTotal(i)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "pen" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("delete-total"),
                                  expression: "$ct('delete-total')",
                                },
                              ],
                              staticClass: "danger",
                              on: {
                                click: function ($event) {
                                  return _vm.removeTotal(i)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "trash" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addTotal()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("add-total"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            { attrs: { value: _vm.toEditTotal != null } },
            [
              _vm.toEditTotal != null
                ? _c("app-total-edit-column", {
                    attrs: {
                      browse: _vm.browse,
                      edit: _vm.toEditTotalIndex >= 0,
                    },
                    on: {
                      close: function ($event) {
                        return _vm.closeEdit()
                      },
                      save: function ($event) {
                        return _vm.saveEdit()
                      },
                    },
                    model: {
                      value: _vm.toEditTotal,
                      callback: function ($$v) {
                        _vm.toEditTotal = $$v
                      },
                      expression: "toEditTotal",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }